<template>
  <div class="g-content">
    <qrcode @success="scanResult" @close="close">
      <van-field
              center
              :maxlength="20"
              v-model="text"
              label="核销码"
              placeholder="请输入"
      >
        <template #button>
          <van-button size="small" type="primary" @click="scanResult(text)">查询</van-button>
        </template>
      </van-field>
    </qrcode>
  </div>
</template>

<script>
  import qrcode from '@/views/components/QrCode';
  import {getByExchangeCode} from '@/api/order/order'

  export default {
    name: 'OrderHxScan',
    components:{
      qrcode
    },
    data(){
      return{
        text: ''
      }
    },
    created() {

    },
    methods : {
      scanResult(e) {
        this.submitResult(e)
      },
      submitResult(code) {
        // 查询核销码对应的订单详情
        getByExchangeCode(code).then(res => {
          if (res.code === 10000) {
            if (res.result) {
              this.$toast('扫描成功');
              this.$router.push({name: 'orderHx', params: {order: res.result}})
            } else {
              this.$toast('未查询到订单')
            }
          }
        })
      },
      close() {
        this.$router.push({name:'my'})
      }
    }
  }
</script>

<style lang="less" scoped>
  .g-content {
    height: calc(100vh - 50px);
  }
</style>
